import { QBankStructureLevelCategory } from '@exam-management/graphql';
import { LockOutlinedIcon, Flex, styled } from '@shared/components';

import type { CategoryExpandState } from './end-adornment';
import { QBankStructureLevelItemRowWithActionState } from './utils';

const StartAdornmentWrapper = styled(Flex)(({ theme }) => ({
  alignItems: 'center',
  color: theme.palette.grey[400],
}));

interface LockAdornmentProps {
  categoryExpandState?: CategoryExpandState;
}

function LockAdornment(props: Readonly<LockAdornmentProps>) {
  const { categoryExpandState } = props;
  return (
    <StartAdornmentWrapper
      sx={(theme) => ({
        pl:
          categoryExpandState?.category === QBankStructureLevelCategory.SubTopic
            ? theme.spacing(3)
            : 0,
      })}
    >
      <LockOutlinedIcon
        sx={(theme) => ({
          width: '24px',
          height: '24px',
          color:
            categoryExpandState?.category === QBankStructureLevelCategory.Part &&
            categoryExpandState?.expanded
              ? theme.palette.common.white
              : theme.palette.grey[600],
        })}
      />
    </StartAdornmentWrapper>
  );
}

interface RowStartAdornmentProps {
  state: QBankStructureLevelItemRowWithActionState;
  categoryExpandState?: CategoryExpandState;
}

export default function RowStartAdornment(props: Readonly<RowStartAdornmentProps>) {
  const { state, categoryExpandState } = props;

  switch (state) {
    case QBankStructureLevelItemRowWithActionState.VIEW:
      return null;
    case QBankStructureLevelItemRowWithActionState.EDIT:
      return null;
    case QBankStructureLevelItemRowWithActionState.LOCK:
      return <LockAdornment categoryExpandState={categoryExpandState} />;
    default:
      return null;
  }
}
